<!-- Sign In Dialog -->
@if(isSignInVisible)
{
<p-dialog
  (onHide)="closeAuth('SIGN_IN')"
  (visibleChange)="onAuthDialogVisibleChange($event)"
  [visible]="isSignInVisible"
  [modal]="true"
  [class.auth-dialog]="isSignInVisible"
  [style]="styles['SIGN_IN']"
  [class]="'m-h-90p w auth-dialog'"
>
  <app-sign-in
    #signInRef
    (activeTypeChange)="changeAction($event)"
    [impersonate]="false"
  ></app-sign-in>
</p-dialog>
}

<!-- Impersonate Sign In Dialog -->
@if(isImpersonateSignInVisible)
{
  <p-dialog
    (onHide)="closeAuth('IMPERSONATE_SIGN_IN')"
    (visibleChange)="onAuthDialogVisibleChange($event)"
    [visible]="isImpersonateSignInVisible"
    [modal]="true"
    [style]="styles['IMPERSONATE_SIGN_IN']"
    [styleClass]="'m-h-90p w auth-dialog'"
  >
    <app-sign-in
      #impersonateSignInRef
      (activeTypeChange)="changeAction($event)"
      [impersonate]="true"></app-sign-in>
    </p-dialog>
  }

<!-- Sign Up Dialog -->
 @if(isSignUpVisible)
 {

<p-dialog
  (onHide)="closeAuth('SIGN_UP')"
  (visibleChange)="onAuthDialogVisibleChange($event)"
  [visible]="isSignUpVisible"
  [modal]="true"
  [style]="styles['SIGN_UP']"
  [styleClass]="'m-h-90p w auth-dialog'"
>
  <app-sign-up
    #signUpRef
    (activeTypeChange)="changeAction($event)"
  ></app-sign-up>
</p-dialog>
 }
<!-- Forgot Password Dialog -->
 @if(isForgotPasswordVisible)
 {
<p-dialog
  (onHide)="closeAuth('RECOVER')"
  (visibleChange)="onAuthDialogVisibleChange($event)"
  [visible]="isForgotPasswordVisible"
  [modal]="true"
  [style]="styles['RECOVER']"
  [styleClass]="'m-h-90p w auth-dialog'"
>
  <app-forgot-password
    #forgotPasswordRef
    (activeTypeChange)="changeAction($event)"
  ></app-forgot-password>
</p-dialog>
 }
<!-- Reset Password Dialog -->
<p-dialog
  (onHide)="closeAuth('RESET_PASSWORD')"
  (visibleChange)="onAuthDialogVisibleChange($event)"
  [visible]="isResetPasswordVisible"
  [modal]="true"
  [style]="styles['RESET_PASSWORD']"
  [styleClass]="'m-h-90p w auth-dialog'"
>
  <app-reset-password
    #resetPasswordRef
    (activeTypeChange)="changeAction($event)"
  ></app-reset-password>
</p-dialog>
